define.alias("ember-composable-helpers/helpers/compact", "preview-grid/helpers/compact");